// Third party
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

// Hooks
import { WelcomeController } from '../../../services';

// Components
import { useError } from '../../useError';
import { TRegisterReq } from '../../../types/requests';
import { TAxiosError, TRegisterRes } from '../../../types/responses';

export function useRegisterAPI() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { handleReqError } = useError();

  const registerAPI = async (data: TRegisterReq) => {
    const payload = {
      username: data.username,
      email: data.email,
      password: data.password,
      first_name: data.first_name,
      last_name: data.last_name,
      phone: data.phone,
      date_of_birth: data.date_of_birth,
    };

    return await WelcomeController().register<TRegisterRes>(payload);
  };

  return useMutation({
    mutationFn: registerAPI,
    onSuccess: async (rsp: TRegisterRes) => {
      if (rsp && rsp.statusText === 'Created') {
        enqueueSnackbar('You’ve registered successfully!', {
          variant: 'success',
        });

        navigate('/login');
      }
    },
    onError: async (error: TAxiosError) => {
      await handleReqError(error);
    },
  });
}
